export interface RouteMetaConfig {
  title: string
  description: string
  image?: string
}

export const routeMetaConfig: Record<string, RouteMetaConfig> = {
  '/': {
    title: 'Home',
    description: 'Designer, startup founder, and creative director living in New York City since 2011.',
    image: '/assets/keyboard-bling.jpg'
  },
  '/about': {
    title: 'About',
    description: 'Designer, startup founder, and creative director. Learn about my experience and background.'
  },
  '/photographs': {
    title: 'Photographs',
    description: 'Photography collection by Taylor Pemberton. Explore my visual work and travels.'
  },
  '/explore': {
    title: 'Explore',
    description: 'Ongoing hobbies, writings, projects, and explorations by Taylor Pemberton.'
  },
  '/explore/gsl': {
    title: 'Great Salt Lake',
    description: 'Exploring the Great Salt Lake - a photo essay by Taylor Pemberton.'
  },
  '/explore/espresso': {
    title: 'Espresso Setup',
    description: 'My home espresso setup and recommendations. Lelit Bianca v3 with DF64 grinder and complete workflow.'
  },
  '/explore/tattoo': {
    title: 'Tattoo',
    description: 'A chronological log of tattoos, artists, and studios.'
  },
  '/explore/4runner': {
    title: '4Runner',
    description: '1996 Toyota 4Runner SR5 - one of the most reliable and capable vehicles ever built.'
  },
  '/explore/date-picker-sandbox': {
    title: 'Date & Time Picker Sandbox',
    description: 'Interactive sandbox for prototyping date and time picker components. Compare iOS, Android, and desktop behavior.'
  },
  '/404': {
    title: 'Page Not Found',
    description: 'The page you\'re looking for doesn\'t exist. Head back to the home page.'
  }
}

